import React, {FC} from "react";
import {SnackbarProvider, useSnackbar, SnackbarKey} from "notistack";
import { styled } from '@mui/material'
import IconButton from "@mui/material/IconButton";
import Close from "@mui/icons-material/Close";
import AppSnackbarContent from "./AppSnackbarContent";

declare module "notistack" {
	interface OptionsObject {
		description?: string;
	}
}

const AppSnackbarProvider: FC<{children: React.ReactNode }> = ({ children }) => {
	return (
		<SnackbarProvider
			preventDuplicate
			autoHideDuration={10000}
			anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
			Components={{
				error: AppSnackbarContent,
				success: AppSnackbarContent,
				warning: AppSnackbarContent,
				info: AppSnackbarContent,
				default: AppSnackbarContent,
			}}
		>
			{children}
		</SnackbarProvider>
		)
}

export default AppSnackbarProvider
